import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  arrowIcon: {
    marginRight: '11px'
  },
  text: {
    color: theme.palette.grey.grey500,
    fontSize: '16px',
    fontWeight: 600,
  },
  icon: {
    marginRight: '11px'
  },
}));

export default useStyles;
